export default {
  slug: 'taller-de-cocina-saludable',
  basepath: 'content/gallery-comida-saludable/',
  images: [
    {
      width: 1199, height: 800, file: '01.jpg', name: ''
    },
    {
      width: 1199, height: 800, file: '1.jpg', name: ''
    },
    {
      width: 534, height: 800, file: '10.jpg', name: ''
    },
    {
      width: 1199, height: 800, file: '11.jpg', name: ''
    },
    {
      width: 1197, height: 800, file: '12.jpg', name: ''
    },
    {
      width: 1199, height: 800, file: '13.jpg', name: ''
    },
    {
      width: 534, height: 800, file: '14.jpg', name: ''
    },
    {
      width: 534, height: 800, file: '15.jpg', name: ''
    },
    {
      width: 1199, height: 800, file: '16.jpg', name: ''
    },
    {
      width: 534, height: 800, file: '17.jpg', name: ''
    },
    {
      width: 534, height: 800, file: '18.jpg', name: ''
    },
    {
      width: 534, height: 800, file: '19.jpg', name: ''
    },
    {
      width: 1199, height: 800, file: '2.jpg', name: ''
    },
    {
      width: 534, height: 800, file: '20.jpg', name: ''
    },
    {
      width: 534, height: 800, file: '21.jpg', name: ''
    },
    {
      width: 534, height: 800, file: '22.jpg', name: ''
    },
    {
      width: 534, height: 800, file: '23.jpg', name: ''
    },
    {
      width: 534, height: 800, file: '24.jpg', name: ''
    },
    {
      width: 1199, height: 800, file: '3.jpg', name: ''
    },
    {
      width: 534, height: 800, file: '4.jpg', name: ''
    },
    {
      width: 1197, height: 800, file: '5.jpg', name: ''
    },
    {
      width: 534, height: 800, file: '6.jpg', name: ''
    },
    {
      width: 534, height: 800, file: '7.jpg', name: ''
    },
    {
      width: 534, height: 800, file: '8.jpg', name: ''
    },
    {
      width: 534, height: 800, file: '9.jpg', name: ''
    },
    {
      width: 534, height: 800, file: 'andrea-de-la-barra.jpg', name: 'Andrea De La Barra'
    },
    {
      width: 1199, height: 800, file: 'constance-lucas---myriam-arredondo.jpg', name: 'Constance Lucas y Myriam Arredondo'
    },
    {
      width: 1199, height: 800, file: 'eva-sufan---christian-herrera.jpg', name: 'Eva Sufán y Christian Herrera'
    },
    {
      width: 1199, height: 800, file: 'francisca-carranza---claudia-carranza.jpg', name: 'Francisca Carranza y Claudia Carranza'
    },
    {
      width: 1199, height: 800, file: 'francisca-kunde---silvia-sapaj.jpg', name: 'Francisca Kunde y Silvia Sapaj'
    },
    {
      width: 1199, height: 800, file: 'leslie-parraguez---ana-molina.jpg', name: 'Leslie Parraguez y Ana Molina'
    },
    {
      width: 1199, height: 800, file: 'lorena-mega---natalia-duque.jpg', name: 'Lorena Mega y Natalia Duque'
    },
    {
      width: 1197, height: 800, file: 'magdalena-buzeta.jpg', name: 'Magdalena Buzeta'
    },
    {
      width: 534, height: 800, file: 'maria-jose-de-la-barra.jpg', name: 'María José De La Barra'
    },
    {
      width: 1197, height: 800, file: 'patricia-zamora---ingrid-barahona.jpg', name: 'Patricia Zamora e Ingrid Barahona'
    },
    {
      width: 1197, height: 800, file: 'viviana-ortega---loreto-rojas.jpg', name: 'Viviana Ortega y Loreto Rojas'
    },
    { width: 1197, height: 800, file: 'ximena-diaz---merahi-ugalde.jpg', name: 'Ximena Díaz y Mehani Ugalde'}
  ]
}
